import ProductSamplingInventoryReport from '../pages/ProductSamplingInventoryReport';
import ProductSamplingRoute from '../pages/ProductSamplingMaintenance';

const productSamplingRoute = {
  public: [],
  auth: [
    {
      name: 'product_sampling_maintenance',
      path: '/maintenance/product-sampling',
      permissions: ['admin', 'PM', 'GPM', 'COO', 'EXECUTIVE'],
      component: ProductSamplingRoute,
    },
    {
      name: 'product_sampling_inventory_report',
      path: '/report/product_sampling_inventory_report',
      permissions: ['PM', 'GPM'],
      component: ProductSamplingInventoryReport,
    },
  ],
};

export default productSamplingRoute;
